import { Button, FormControl, Grid, Input, InputLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { FileCopy } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import akmApi from "../../../../../apis/akmApi";
import { URL_AKM } from "../../../../../config";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";

const ListProdiUnik = (props) => {
  const [isFetching, setisFetching] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [isOpenImport, setisOpenImport] = useState(false);
  const [listProdiUnik, setlistProdiUnik] = useState([]);
  const [id, setId] = useState(null);
  const [val, setVal] = useState([]);
  const [kodeProdi, setkodeProdi] = useState("");
  const [namaProdiPtn, setnamaProdiPtn] = useState(null);
  const [namaProdiUnik, setnamaProdiUnik] = useState(null);
  const [importFile, setimportFile] = useState(null);

  const [pages, setpage] = useState(0);
  const [size, setsize] = useState(10);
  const [totalPages, settotalPages] = useState(0);
  const [numberOfElements, setnumberOfElements] = useState(0);
  const [totalElements, settotalElements] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [listError, setListError] = useState("");
  const listRequest = useRef(0);

  useEffect(() => {
    let active = true;
    const getDatas = async () => {
      await props.cekCookies();
      if (active && props.account !== null) {
        setpage(0);
        fetchUniqueListProdi(0, searchQuery, size);
      }
    };

    getDatas();
    return () => { active = false; listRequest.current += 1; };
  }, []);

  const fetchUniqueListProdi = async (pages, search, size) => {
    const request = ++listRequest.current;
    setisFetching(true);
    setListError("");
    try {
      const respons = await akmApi.get(URL_AKM.LIST_PRODI_UNIK, {params: {page: pages, search, size}});
      if (request === listRequest.current) {
        if (!respons || !respons.data || !respons.data.data || !Array.isArray(respons.data.data.content)) {
          throw new Error("Daftar prodi tidak tersedia.");
        }
        const responseAPI = respons.data.data;
        setlistProdiUnik(responseAPI.content);
        settotalPages(responseAPI.totalPages);
        setnumberOfElements(responseAPI.numberOfElements);
        settotalElements(responseAPI.totalElements);
      }
    } catch (error) {
      if (request === listRequest.current) {
        setlistProdiUnik([]);
        settotalPages(0);
        setnumberOfElements(0);
        settotalElements(0);
        setListError("Daftar prodi gagal dimuat. Silakan coba lagi.");
      }
    } finally {
      if (request === listRequest.current) setisFetching(false);
    }
  };

  const handleOpenModal = async () => {
    setisOpen(true);
  };

  const handleCloseModal = async () => {
    setisOpen(false);
  };

  const handleOpenModalImport = async () => {
    setisOpenImport(true);
  };

  const handleCloseModalImport = async () => {
    setisOpenImport(false);
  };

  const handleChangePage = async (e, newPage) => {
    setpage(newPage);

    fetchUniqueListProdi(newPage, searchQuery, size);
  };

  const handleChangeRowsPerPage = (e) => {
    setpage(0);
    const nextSize = Number(e.target.value);
    setsize(nextSize);

    fetchUniqueListProdi(0, searchQuery, nextSize);
  };

  const handleChangeNamePp = async (e) => {
    setSearchQuery(e.target.value);
    setpage(0);
    fetchUniqueListProdi(0, e.target.value, size);
  };

  const handleThrowPaketProgram = async (id) => {
    const respons = await akmApi.get(URL_AKM.LIST_PRODI_UNIK, { params: { kodeProdi: id } });

    const responseAPI = respons.data.data.content[0];

    setisOpen(true);

    setkodeProdi(responseAPI.kodeProdi);
    setnamaProdiPtn(responseAPI.namaProdiPtn);
    setnamaProdiUnik(responseAPI.namaProdiUnik);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const getrespons = await akmApi.get(URL_AKM.LIST_PRODI_UNIK, { params: { kodeProdi: kodeProdi } });

    const dataProdi = {
      kodeProdi: kodeProdi,
      namaProdiPtn: namaProdiPtn,
      namaProdiUnik: namaProdiUnik,
    };

    let response = null;

    if (getrespons.data.data.empty === true) {
      response = await akmApi.post(URL_AKM.LIST_PRODI_UNIK, dataProdi).catch(function (error) {
        setkodeProdi(null);
        setnamaProdiPtn(null);
        setnamaProdiUnik(null);
      });

      fetchUniqueListProdi(pages, searchQuery, size);
    } else {
      response = await akmApi.put(URL_AKM.LIST_PRODI_UNIK + "?idNamaProdiUnikPtn=" + getrespons.data.data.content[0].idNamaProdiUnikPtn, dataProdi).catch(function (error) {
        setkodeProdi(null);
        setnamaProdiPtn(null);
        setnamaProdiUnik(null);
      });

      fetchUniqueListProdi(pages, searchQuery, size);
    }

    handleCloseModal();
    console.log("response => ", response);
  };

  const onFileChange = (event) => {
    setimportFile(event.target.files[0]);
  };

  const handleSubmitFile = async (event) => {
    setisFetching(true);
    event.preventDefault();

    if (importFile !== "" && importFile.size < 1000000) {
      let data = new FormData();
      data.append("file", importFile);
      const response = await akmApi.post(URL_AKM.LIST_PRODI_UNIK + "/import", data).catch(function (error) {
        console.log("====================================");
        console.log(error);
        console.log("====================================");
      });

      console.log("response submit", response);
      if (response) {
        alert("File Dokumen sukses diupload !!");
        handleCloseModalImport();
        document.getElementById("file").value = "";
        fetchUniqueListProdi(pages, searchQuery, size);
        setisFetching(false);
      }
    } else {
      alert("File Dokumen harus < 1Mb ..!!");
      setisFetching(false);
    }
  };

  return (
    <div className="wrapper">
      <LoaderModal isFetching={isFetching} />
      <Sidebar account={props.account} />
      <div id="content" style={{ paddingBottom: "50px" }}>
        {/* {this.loadSnackbar()} */}
        <Navbar title={"List Prodi"} />
        {listError && <div role="alert" className="alert alert-warning">
          {listError} <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => fetchUniqueListProdi(pages, searchQuery, size)}>Coba lagi</button>
        </div>}
        {/* {this.modalCreateUpdate()} */}
        <Row>
          <Col sm={7}>
            <Button variant="outlined" color="primary" onClick={handleOpenModal} style={{ marginRight: 5 }}>
              <AddIcon fontSize="small" />
              Tambah Prodi
            </Button>
            <Button variant="outlined" color="success" onClick={handleOpenModalImport}>
              <FileCopy exce fontSize="small" />
              Import Excel
            </Button>
          </Col>
          <Col align="right">
            <FormControl>
              <InputLabel htmlFor="standard-adornment-password">Cari Kode Prodi</InputLabel>
              <Input onChange={handleChangeNamePp} placeholder="Cari Kd Prodi / Nama Prodi" id="namaProgram" endAdornment={<SearchIcon position="end" />} />
            </FormControl>
          </Col>
        </Row>
        <Row style={{ marginTop: 25 }}>
          <Col>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Kode Prodi</TableCell>
                    <TableCell align="left">Nama Program Studi</TableCell>
                    <TableCell align="left">Nama Unik Program Studi</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listProdiUnik.length > 0 &&
                    listProdiUnik.map((list, i) => (
                      <TableRow key={i}>
                        <TableCell>{list.kodeProdi}</TableCell>
                        <TableCell>{list.namaProdiPtn}</TableCell>
                        <TableCell>{list.namaProdiUnik}</TableCell>
                        <TableCell align="center">
                          {
                            <div className="button-group">
                              <button className="btn btn-outline-info btn-sm" onClick={() => handleThrowPaketProgram(list.kodeProdi)}>
                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                              </button>
                            </div>
                          }
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination component="div" count={totalElements} page={pages} onPageChange={handleChangePage} rowsPerPage={size} onChangeRowsPerPage={handleChangeRowsPerPage} />
            </TableContainer>
          </Col>
        </Row>
      </div>
      <Modal show={isOpen} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Program Studi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <Row style={{ marginBottom: 40 }}>
              <Col>
                <FormControl>
                  <InputLabel htmlFor="standard-adornment-password">Kode Prodi</InputLabel>
                  <Input onChange={(e) => setkodeProdi(e.target.value)} value={kodeProdi} placeholder="Kode Prodi" id="kodeProdi" />
                </FormControl>
              </Col>
              <Col>
                <FormControl>
                  <InputLabel htmlFor="standard-adornment-password">Nama Prodi Perguruan Tinggi</InputLabel>
                  <Input onChange={(e) => setnamaProdiPtn(e.target.value)} value={namaProdiPtn} placeholder="Nama Prodi Perguruan Tinggi" id="namaProdiPtn" />
                </FormControl>
              </Col>
              <Col>
                <FormControl>
                  <InputLabel htmlFor="standard-adornment-password">Nama Prodi Unik</InputLabel>
                  <Input onChange={(e) => setnamaProdiUnik(e.target.value)} value={namaProdiUnik} placeholder="Nama Prodi Unik" id="namaProdiUnik" />
                </FormControl>
              </Col>
            </Row>
            <Grid item xs={12}>
              <Button variant="outlined" color="secondary" style={{ float: "left" }} onClick={() => handleCloseModal()}>
                <li className="fa fa-close"> Batal</li>
              </Button>
              <Button variant="outlined" color="primary" type="submit" style={{ float: "right" }}>
                <li className="fa fa-save"> Simpan</li>
              </Button>
            </Grid>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={isOpenImport} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Import Program Studi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitFile}>
            <Row style={{ marginBottom: 40 }}>
              <Col>
                <input type="file" className="form-control" required onChange={onFileChange} id="file" accept=".xlsx" />
              </Col>
              <Col>
                <h5>Prosedur Upload Prodi :</h5>
                <ol>
                  <li>Download format dokumen (.xlsx)&nbsp;</li>
                  <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                  <li>
                    Format dokumen wajib &nbsp;
                    <span class="text-danger">
                      <strong>*</strong>
                    </span>
                    <strong>.xlsx</strong>
                    <span class="text-danger">
                      <strong>*</strong>
                    </span>
                  </li>
                  <li>
                    Prodi Akan di update berdasarkan <strong>KODE PRODI</strong> yang telah tersedia di system,
                  </li>
                  <li>KODE PRODI di sistem yang tidak sesuai dengan file upload akan otomatis terhapus</li>
                  <li>PASTIKAN file yang akan di upload sudah sesuai dengan data terbaru.</li>
                  <br />
                  <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + "/Matcher_Nama_Prodi.xlsx"}>
                    <li className="fa fa-download"> Download</li>
                  </a>
                </ol>
              </Col>
            </Row>
            <Grid item xs={12}>
              <Button variant="outlined" color="secondary" style={{ float: "left" }} onClick={() => handleCloseModalImport()}>
                <li className="fa fa-close"> Batal</li>
              </Button>
              <Button variant="outlined" color="primary" type="submit" style={{ float: "right" }}>
                <li className="fa fa-save"> Simpan</li>
              </Button>
            </Grid>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(ListProdiUnik);
